// Copyright (c) 2017 Deere & Company

import actions from '../../actions-list';
import {getDefaultState} from '../state';

const resetCreditMemoDisabled = () => getDefaultState().isDisplayCreditMemoDisabled;

const updateCreditMemoDisabled = (state, action) => action.isDisabled;

export default (state = getDefaultState().isDisplayCreditMemoDisabled, action) => {

    const actionTypes = {
        [actions.RESET_CREDIT_MEMO_REPORT]: resetCreditMemoDisabled,
        [actions.UPDATE_CREDIT_MEMO_DISPLAY_DISABLED]: updateCreditMemoDisabled
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/reports/credit-memo/reducers/is-display-credit-memo-disabled.js